module.exports = __webpack_public_path__ + "ProximaNova-Regular.52b03ccd1a2fde8a21ff368603df27e5.woff";